module.exports = __webpack_public_path__ + "media/site_templates/www.localgardeners.com.au/images/feature_2-9b0bf18111fa73a44a5d3f80a9903a2f.jpeg";